/** 
   Service providing functions for the admin account for working with data for all suppliers.
*/

import { RawSuppliersList, Supplier } from 'types';
import { getAllRawSuppliers } from 'lib/firebase';
import { getSupplierInfo } from './supplier';

/** Admin only. Get an array of all Suppliers. */
export const getAllSuppliers = async (): Promise<Supplier[]> => {
    return await getAllRawSuppliers().then((rawSuppliers) => {
        return Promise.all(
            Object.entries(rawSuppliers).map(async (supplier) => {
                const supplierId = supplier[0];
                return await getSupplierInfo(supplierId).then((info) => {
                    return { supplierId, info } as Supplier;
                });
            })
        ).then((allSuppliers) => {
            return allSuppliers;
        });
    });
};

/** Admin only. Get map of supplierIds to supplier names. */
export const getSupplierIdsToNamesMap = async (): Promise<RawSuppliersList> => {
    return getAllRawSuppliers();
};
